<template>
  <el-dialog
    :title="modalTitle"
    :visible="visible"
    width="100px"
    center
    :close-on-click-modal="false"
    @close="close()"
  >

  <template>
    <div v-loading="loading != 0" class="modal-fade">
      <el-form >
            <div class="gridTemplate" style="padding:10px">
            <el-form-item>
              <el-input v-model="filter.name" :placeholder="i18nValues['variety']"></el-input>
            </el-form-item>

            <el-form-item>
              <el-input v-model="filter.brand" placeholder="Brand"></el-input>
            </el-form-item>

            <el-form-item>
              <el-input v-model="filter.netWeight" :placeholder="i18nValues['netWeight']"></el-input>
            </el-form-item>

            <el-form-item>
              <el-input v-model="filter.grossWeight" :placeholder="i18nValues['grossWeight']"></el-input>
            </el-form-item>

            <el-form-item>
              <el-input v-model="filter.batch" :placeholder="i18nValues['batch']"></el-input>
            </el-form-item>

            <el-form-item>
                    <el-button
                        @click="retrievePalletsForModal()"
                        icon="fas fa-search"
                        id="searchButton"
                        style="float: right;"
                        size="small"
                        class="btn-primary"
                    >
                    {{ i18nValues['search'] }}
                    </el-button>
            </el-form-item>          
          </div>
        </el-form>

          <!-- Show Pallets Table -->
          <div style="margin:0 auto;padding:40px;">
            <el-table
            :data="PalletItemsSubListToAdd"
            style="width: 150"
            row-key="id"     
            id="PalletItemsList"  
            class="table table-hover table-striped"
            align="center"          
            :empty-text="i18nValues['noDataAvailable']"
            :tree-props="{children: 'items'}"
            >   
            
              <!-- PALLET TYPE -->
              <el-table-column
                 prop="palletType" 
                 :label="i18nValues['palletType']"        
                 align="left"
                 width="120">
              </el-table-column>  

              <!-- ID NUMBER -->
              <el-table-column
                 prop="idNumber" 
                 :label="i18nValues['idNumber']"        
                 align="center"
                 width="110">
              </el-table-column>  

              <!-- PALLET -> ITEM -> PRODUCT.NAME -->
              <el-table-column 
                prop="product.name"
                :label="i18nValues['variety']"                        
                align="center"
                width="140">
              </el-table-column>

              <!-- PALLET -> ITEM -> BRAND.NAME -->
              <el-table-column
                prop="product.brand"
                label="Brand"                       
                align="center"
                width="100">
              </el-table-column>

              <!-- PALLET -> ITEM -> EVENT.NAME -->
              <el-table-column
                prop="product.event.name"
                :label="i18nValues['event']"                       
                align="center"
                width="100">
              </el-table-column>                      

              <!-- PALLET -> ITEM -> BATCH-->
              <el-table-column
                prop="batch"
                :label="i18nValues['batch']"                       
                align="right"
                width="100">
              </el-table-column>                     

              <!-- PALLET + ITEM -> NETWEIGHT -->
              <el-table-column
                prop="netWeight"
                :label="i18nValues['netWeight']"                        
                align="right"
                width="100">
              </el-table-column>      
                      
              <!-- PALLET + ITEM -> GROSSWEIGHT -->
              <el-table-column
                prop="grossWeight"
                :label="i18nValues['grossWeight']"                       
                align="right"
                width="100">
              </el-table-column>  

              <!-- BAGS NUMBER-->
              <el-table-column
                prop="bagsNumber"
                :label="i18nValues['bagsNumber']"             
                align="right"
                width="100">
              </el-table-column>  

              <!-- BAGS NUMBER-->
              <el-table-column
                prop="status"
                :label="i18nValues['state']"             
                align="right"
                width="100">
              </el-table-column> 

                        <!-- ADD -->
                        <el-table-column width="90" align="right">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.isPallet"
                                    class="text-info"
                                    icon="fas fa-check"
                                    size="small"
                                    align="center"
                                    title="agregar"
                                    @click="associate(scope.row)"
                                ></el-button>
                            </template>
                        </el-table-column>                         
                    </el-table>  

                    <!-- Total Pallets Count -->
                    <div v-if="totalSelectedPallets > 0" style="display: flex; justify-content: flex-end; margin-top: 10px;">
                        <span style="color: #555; font-size: 12px;">{{ i18nValues['totalPallets'] }}: {{ totalSelectedPallets }}</span>
                    </div>

                    <div v-if="90 > 10" style="height: 15px"></div>
                        <PaginationFunctional
                            sublistName="PalletItemsSubListToAdd"
                            :fullList="PalletItemsListToAdd"
                            :tableSize="15"
                            @paginationChange="paginationChange"
                            class="text-center"
                        />            
          </div>
    </div>

            <div class="full-width d-flex justify-content-end mt-2">
              <el-button style="float: left;" icon="fas fa-check" size="small" class="btn-primary" @click="savePallet()">
                {{ i18nValues['accept'] }}
              </el-button>       
              <label ></label>    
              <label ></label>  
              <label ></label>  
              <label ></label>             
            </div>
  </template>
  </el-dialog>
</template>

<script>
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
import PaginationFunctional from "@/components/PaginationFunctional.vue"
export default {
    name: "PalletModal",

    computed: {
      loading: get("pallet/loading"),
      globalFieldSite: get("globalFieldSite"),
      globalCampaign: get("globalCampaign"),
      totalSelectedPallets() {
        return this.PalletItemsList ? this.PalletItemsList.filter(item => item.isPallet).length : 0;
      },
    },

    watch: {
      globalFieldSite() {
        this.PalletItemsListToAdd = [];
        this.retrievePalletItems();
      },
    },

    components: {
      PaginationFunctional,
    },

    props: ["id","modalTitle", "visible","action","PalletItemsList","dispatchType"],

    data() {
      return {

        pagesize: 5,
        currentPage: 1,

        PalletItemsListToAdd: [],
        PalletItemsSubListToAdd: [],

        filter: {
          name: null,
          netWeight: null,
          grossWeight: null,
        },

      };
    },
    methods: {

      savePallet(){
        this.$emit("update:visible", false);
        this.$emit("pallets-updated");
      },

      retrievePalletItems() {
        this.filter.fieldSiteId = this.globalFieldSite.id;
        this.filter.campaignId = this.globalCampaign ? this.globalCampaign.id : null;
        this.filter.dispatchType = 'plane';
        this.$store.dispatch("pallet/retrievePalletswithOutOrders" , this.filter).then((res)=>{
            this.PalletItemsListToAdd = this.excludePalletsAlreadyOnOrder(res || []);
            this.translate();
        }); 
      },

      close() {
        this.$emit("update:visible", false);
      },

      handleCurrentChange(currentPage) {
        this.currentPage = currentPage;
      },

      excludePalletsAlreadyOnOrder(list) {
        const orderIds = new Set(
          (this.PalletItemsList || [])
            .map((row) => row.id)
            .filter((id) => id != null)
        );
        return list.filter((p) => !orderIds.has(p.id));
      },

      associate(pallet) {
        if (!pallet || pallet.id == null) return;
        const alreadyOnOrder = (this.PalletItemsList || []).some(
          (row) => row.isPallet && row.id === pallet.id
        );
        if (alreadyOnOrder) return;

        const idxFull = this.PalletItemsListToAdd.indexOf(pallet);
        if (idxFull === -1) return;
        this.PalletItemsListToAdd.splice(idxFull, 1);

        const idxSub = this.PalletItemsSubListToAdd.indexOf(pallet);
        if (idxSub !== -1) {
          this.PalletItemsSubListToAdd.splice(idxSub, 1);
        }

        pallet.code = pallet.id;
        this.PalletItemsList.push(pallet);
      },

      retrievePalletsForModal(){
        this.filter.campaignId = this.globalCampaign ? this.globalCampaign.id : null;
        if(this.filter.name == ""){
          this.filter.name = null;
        }
        if(this.filter.brand == ""){
          this.filter.brand = null;
        }
        if(this.filter.netWeight == ""){
          this.filter.netWeight = null;
        }
        if(this.filter.grossWeight == ""){
          this.filter.grossWeight = null;
        }
        if(this.filter.batch == ""){
          this.filter.batch = null;
        }
 
        if((this.filter.name == "" || this.filter.name == null) && (this.filter.brand == "" || this.filter.brand == null) && (this.filter.netWeight == "" || this.filter.netWeight == null) && (this.filter.grossWeight == "" || this.filter.grossWeight == null) && (this.filter.batch == "" || this.filter.batch == null)){
          this.retrievePalletItems();
        } else {
          this.$store.dispatch("pallet/retrievePalletsForModal", this.filter).then((res)=>{
            this.PalletItemsListToAdd = this.excludePalletsAlreadyOnOrder(res || []);
            this.check(this.PalletItemsListToAdd);
            this.translate();
          });
        } 
      },

      check(list){
        for(var i = 0; i < list.length; i++){
          for(var j = 0; j < list.length; j++){
            if(list[i].id == list[j].id && i != j){
              list.splice(j,1);
            }
          }
        }
      },

      translate(){
        for(var k = 0; k < this.PalletItemsListToAdd.length ; k++){
              if(this.PalletItemsListToAdd[k].status == "available"){
                this.PalletItemsListToAdd[k].status = this.i18nValues['available'];
              }
              if(this.PalletItemsListToAdd[k].status == 'forLoading'){
                this.PalletItemsListToAdd[k].status = this.i18nValues['forLoading'];
              }
              if(this.PalletItemsListToAdd[k].status == 'loaded'){
                this.PalletItemsListToAdd[k].status = this.i18nValues['loaded'];
              }
              if(this.PalletItemsListToAdd[k].status == 'dispatched'){
                this.PalletItemsListToAdd[k].status = this.i18nValues['sent'];
              }
              if(this.PalletItemsListToAdd[k].status == 'onHold'){
                this.PalletItemsListToAdd[k].status = this.i18nValues['onHold'];
              }
              if(this.PalletItemsListToAdd[k].status == 'grainPort'){
                this.PalletItemsListToAdd[k].status = this.i18nValues['grainPort'];
              }
              if(this.PalletItemsListToAdd[k].status == 'grainConsumption'){
                this.PalletItemsListToAdd[k].status = this.i18nValues['grainConsumption'];
              }
              if(this.PalletItemsListToAdd[k].status == 'erased'){
                this.PalletItemsListToAdd[k].status = this.i18nValues['erased'];
              }
            }
      },


    },
};
</script>

<style scoped>
.PalletItemsList{
  zoom:60%;
  align-self: center;
  width: 100%;
}
</style>